import React from 'react'
import PropTypes from 'prop-types'
import { Modal as EPModal, Copy, Button, Flex } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'

const EditBookingModal = ({ isShown, onClose, onCancelBooking, pageName }) => {
    return <EPModal isShown={isShown} onClose={onClose} width='812px' height={['100%', 'auto']} label=' ' showModalTitle={false}>
        <Flex mt={['1em', '3em']} flexDirection='column' textAlign='center'>
            <Copy size={['large', 'xxLarge']} fontWeight='medium' color='accent_dark' padding='1em 0em'>
                <FormattedMessage defaultMessage='¿Necesitas modificar tu reserva?'/>
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='Para modificar tu reserva, debes cancelar la que ya tienes y realizar una nueva.'/>
            </Copy>
            <Flex width='100%' alignSelf='end' alignContent='center' justifyContent='center' mt='1em' mb={['0em', '1em']} flexDirection={['column-reverse', 'row']}>
                <Button.bordered dataTest='refuse-edit-booking-button' onClick={() => {
                    trackTealiumEvent(RentalCarEvents.keepModifyButtonRentalCarBooking(pageName))
                    onClose()
                }} fontWeight='bold' mr={['0em', '1em']} > <FormattedMessage defaultMessage='No, mantener'/></Button.bordered>
                <Button dataTest='accept-edit-booking-button' onClick={() => {
                    trackTealiumEvent(RentalCarEvents.cancelModifyButtonRentalCarBooking(pageName))
                    onCancelBooking()
                }} fontWeight='bold' mb={['1em', '0em']}> <FormattedMessage defaultMessage='Cancelar y volver a reservar'/></Button>
            </Flex>
        </Flex>
    </EPModal>
}

EditBookingModal.propTypes = {
    isShown: PropTypes.bool,
    onCancelBooking: PropTypes.func,
    onClose: PropTypes.func,
    pageName: PropTypes.string,
}
export default EditBookingModal
